import { useRouteLoaderData } from "react-router";

import type { EventLoaderData } from "~/loaders/event";

/**
 * The event route's SSR payload. It already fetches every market, so the
 * initial grid can render real rows before the client-side query resolves.
 */
export const useEventLoaderData = (): EventLoaderData | undefined =>
  useRouteLoaderData("routes/event") as EventLoaderData | undefined;
